import "./ImageCard.css";
import { useState, useEffect } from "react";
import { getOptimizedImage } from "../../utils/imageOptimizer";

const ImageCard = ({ img, alt, fallback }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const optimized = getOptimizedImage(img, fallback);
    setImageSrc(optimized.src);
  }, [img, fallback]);

  const handleError = () => {
    if (imageSrc && imageSrc.endsWith(".webp")) {
      // Fallback to original format if WebP fails
      setImageSrc(fallback || img);
    } else {
      setHasError(true);
    }
  };

  return (
    <div className="card-image-div">
      {!isLoaded && !hasError && (
        <div className="image-placeholder">
          <div className="loading-spinner"></div>
        </div>
      )}
      {imageSrc && (
        <img
          src={imageSrc}
          alt={alt}
          className={`card-img ${isLoaded ? "loaded" : ""}`}
          loading="lazy"
          decoding="async"
          onLoad={() => setIsLoaded(true)}
          onError={handleError}
        />
      )}
    </div>
  );
};

export default ImageCard;
